export default "__VITE_ASSET__ClWfdXKd__"